<script>
  export let onPrev;
  export let onNext;
</script>

<!-- Previous Button -->
<div class="btn-wrapper left-btn left-0">
  <button aria-label="Previous project" on:click={onPrev} class="nav-btn">
    <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M15 19l-7-7 7-7"
      />
    </svg>
  </button>
</div>

<!-- Next Button -->
<div class="btn-wrapper right-btn right-0">
  <button aria-label="Next project" on:click={onNext} class="nav-btn">
    <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M9 5l7 7-7 7"
      />
    </svg>
  </button>
</div>

<style>
  .btn-wrapper {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 60px;
    height: 80px;
    padding: 1px;
    background: linear-gradient(45deg, #3b82f6, #8b5cf6, #ec4899, #3b82f6);
    background-size: 200% 200%;
    animation: gradient 4s linear infinite;
    z-index: 20;
  }

  .left-btn {
    border-radius: 0 12px 12px 0;
    padding-left: 0;
  }

  .right-btn {
    border-radius: 12px 0 0 12px;
    padding-right: 0;
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  .nav-btn {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.95);
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .left-btn .nav-btn {
    border-radius: 0 11px 11px 0;
  }

  .right-btn .nav-btn {
    border-radius: 11px 0 0 11px;
  }

  :global(.dark) .nav-btn {
    background: rgba(31, 41, 55, 0.95);
  }

  .btn-wrapper:hover {
    animation: gradient 2s linear infinite;
    width: 65px;
  }

  .nav-btn:hover {
    transform: scale(0.98);
    background: white;
  }

  :global(.dark) .nav-btn:hover {
    background: rgb(31, 41, 55);
  }

  .icon {
    width: 24px;
    height: 24px;
    stroke: #374151;
    transition: transform 0.2s ease;
  }

  :global(.dark) .icon {
    stroke: #e5e7eb;
  }

  .nav-btn:hover .icon {
    transform: scale(1.1);
  }

  /* Mobile styles */
  @media (max-width: 768px) {
    .btn-wrapper {
      width: 40px;
      height: 60px;
    }

    .icon {
      width: 20px;
      height: 20px;
      stroke-width: 2.5; /* Slightly thicker for visibility on mobile */
    }

    .btn-wrapper:hover {
      width: 45px; /* Smaller expansion on mobile */
    }
  }
</style>
